/* eslint-disable import/no-named-as-default */
import { combineReducers } from "@reduxjs/toolkit";
import FichaInfoSlice from "./slices/components/fichaInfo/FichaInfoSlice";
import CalendarSlice from "./slices/components/calendar/CalendarSlice";
import ThemeSlice from "./slices/ThemeSlice";

const rootReducer = combineReducers({
  FichaInfoSlice,
  CalendarSlice,
  ThemeSlice
});

export default rootReducer;
